import React from "react";
import EventCard from "./EventCard";
import { useApp } from "@/context/AppContext";

export default function EventListView({ events }) {
  const { t } = useApp();
  if (!events.length) return <div className="text-center py-20 border border-dashed border-foreground" data-testid="empty-state">{t("noResults")}</div>;
  const groups = {};
  events.forEach(e => { const key = e.start_date.slice(0, 7); (groups[key] = groups[key] || []).push(e); });
  return (
    <div data-testid="list-view">
      {Object.keys(groups).sort().map(k => {
        const [y, m] = k.split("-");
        return (
          <section key={k} className="mb-8">
            <h2 className="gg-month-header sticky top-14 md:top-16 bg-background z-10 !mt-0 !mb-3 !text-2xl md:!text-3xl py-2" data-testid={`month-${k}`}>
              {t("monthHeaders")[parseInt(m, 10) - 1]} {y}
            </h2>
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-3 md:gap-4">
              {groups[k].map(e => <EventCard key={e.event_id} event={e} />)}
            </div>
          </section>
        );
      })}
    </div>
  );
}
